/* eslint-disable no-console */

import { Link, useRouteError } from 'react-router-dom'

import Icon from '@shared/assets/images/icon.svg'
import { Button } from '@shared/components/Button'
import { Text } from '@shared/components/Text'

export function ErrorPage() {
  const error = useRouteError() as { message: string }

  console.error({ error })

  return (
    <section className="flex h-full flex-col items-center justify-center gap-4">
      <img src={Icon} alt="BrazaLink" className="h-auto w-20" />

      <Text className="text-text-secondary font-body text-base">
        {'Ocorreu um erro ao carregar a página, contate o suporte!'}
      </Text>

      <Button asChild className="w-fit px-10">
        <Link to="/" className="text-center">
          {'Ir para a página inicial'}
        </Link>
      </Button>
    </section>
  )
}
